import { isDayKey } from '../../helpers/cinema-time-zone.ts';

/** The server answers 422 for an ambience date further than this many years from today. */
const MAX_YEARS_FROM_TODAY = 2;

/** The dates the server accepts around `today`, for a date input's `min` and `max`; the 29th to 31st count as the 28th. */
export function dateBounds(today: string): { min: string; max: string } {
    if (!isDayKey(today)) return { min: today, max: today };
    const [year, month, dayOfMonth] = [Number(today.slice(0, 4)), today.slice(5, 7), Number(today.slice(8))];
    const day = String(Math.min(dayOfMonth, 28)).padStart(2, '0');
    return {
        min: `${year - MAX_YEARS_FROM_TODAY}-${month}-${day}`,
        max: `${year + MAX_YEARS_FROM_TODAY}-${month}-${day}`
    };
}
